<template>
    <div class="paginated-content">
        <slot :html="data" v-bind="this"></slot>
    </div>
</template>

<script>
    import axios from 'axios';
    import debounce from 'lodash/debounce';

    export default {
        props: {
            endpoint: {
                type: String,
                required:true
            },
            query: {
                type: String,
                default: 'page'
            }
        },
        data() {
            return {
                data: null,
                loading: false
            }
        },
        methods: {
            setLoading: debounce(function(value) {
                this.loading = value;
            }, 200),
            handlePageChanged(page) {
                this.loading = true;
                this.setLoading(true);
                axios.get(this.endpoint, { params: { [this.query]:page }})
                    .then(response => {
                        this.data = response.data;
                    })
                    .finally(()=>{
                        this.setLoading(false);
                    })
            }
        }
    }
</script>